module.exports = __webpack_public_path__ + "static/media/ClinicaSantaIsabel.23c8ee49.svg";